import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Pagination, Select, Text } from '../../components';
import { AppAction, ShiftSchedulerAction } from '../../store/actions';
import styles from './styles';
import { Row, Modal, Col, Avatar, Grid, Tabs, Spin, List } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { ApiCaller, Colors, Utils } from '../../config';
import TextField from '../../components/TextField';
import DropDown from '../../components/DropDown';
import filter from '../../assets/images/filter.png';
import { io } from 'socket.io-client';

import './style.css';
import {
    LineChart,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    AreaChart,
    ReferenceLine,
    Area,
} from 'recharts';
import DoughnutChart from '../../components/Charts/DoughnutChart';

import { HiOutlineBellAlert } from 'react-icons/hi2';
import { IoIosSearch } from 'react-icons/io';
import { UserOutlined } from '@ant-design/icons';
import { IoIosArrowForward } from 'react-icons/io';
import dash1 from '../../assets/images/dash1.png';
import dash2 from '../../assets/images/dash2.png';
import dash3 from '../../assets/images/dash3.png';
import dash4 from '../../assets/images/dash4.png';
import dashboard from '../../assets/images/dashbaord.jpg';
import avatar from '../../assets/images/avatar.jpg';

// import second from '../../assets/images/'
import BasicText from '../../components/Text/BasicText';
import SelectField from '../../components/TextField/SelectField';
import RangeDatePicker from '../../components/Picker/RangePicker';
import LoadOnScroll from '../../components/LoadOnScroll';
import Circular from '../../components/Loader/Circular';

import useColors from '../../hooks/useColors';
import { FaBars, FaClock, FaFileShield, FaUserSecret } from 'react-icons/fa6';
import App from '../WorkForceManagement/Scheduler/App';
import moment from 'moment';
import LiveTracking from './LiveTracking';
import { BiSolidCalendarEdit } from 'react-icons/bi';
import DashboardActionBar from '../../components/DashboardActionBar';
import dayjs from 'dayjs';
import currentDate from '../../config/util/index';
import { ViewType } from '../WorkForceManagement/Scheduler/react-big-schedule/dist';

const Dashboard = () => {
    const { colorPrimary, colorSecondary } = useColors();
    const scrn = Grid.useBreakpoint();
    const scrollContainerRef = useRef(null);

    // clearing shifts on unmounting as it is creating a repetative data once the component get mounts again.
    useEffect(() => {
        return () => {
            dispatch(ShiftSchedulerAction.ClearShifts());
        };
    }, []);

    const user = JSON.parse(localStorage.getItem('user'));
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [state, setState] = useState({
        limit: 100,
        page: 1,
        tabKey: 0,
        today: true,
        filterDrawer: {
            schedule: '',
            user: '',
            eligiblity: '',
            confirmedShifts: '',
        },
    });

    const [currentConfigOfScheduler, setCurrentConfigOfScheduler] = useState({
        date: dayjs().format('YYYY-MM-DD') || currentDate(),
        viewType: ViewType?.Week,
    });

    // Current week date range: Monday to Sunday
    const currentWeekStart = dayjs().startOf('week').format('YYYY-MM-DD');
    const currentWeekEnd = dayjs().endOf('week').format('YYYY-MM-DD');

    const { loader, shiftsData } = useSelector(
        (state) => state?.ShiftSchedulerReducer,
    );

    const { notificationCount } = useSelector((state) => state?.GeneralReducer);

    const [lineChartData, setLineChartData] = useState([]);
    const [doughnutChartData, setDoughnutChartData] = useState({});
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const [resources, setResources] = useState([]);
    const { data: shiftRecords, paginate } = shiftsData;
    const [isModalVisible, setModalVisible] = useState(false);
    const [isGuardsModalVisible, setGuardsModalVisible] = useState(false);
    const [lineChartDateRange, setLineChartDateRange] = useState([]);
    const [doughnutChartDateRange, setDoughnutChartDateRange] = useState([]);
    const [dateRange, setDateRange] = useState([]);

    const [shiftsHasMore, setShiftsHasMore] = useState(true);
    const [totalScheduleObjectCount, setTotalScheduleObjectCount] = useState(0);
    const [forceFullyStopHasMoreShifts, setForceFullyStopHasMoreShifts] =
        useState(false);

    const handleOpenModal = () => {
        setModalVisible(true);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
    };

    const handleOpenGuardsModal = () => {
        setGuardsModalVisible(true);
    };

    const handleCloseGuardsModal = () => {
        setGuardsModalVisible(false);
    };

    const todayGuards = resources.filter(
        (resource) => resource.name && !resource.name.includes('Unassigned'),
    );

    // Scroll to top when new data is updated
    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({
                top: 0,
                behavior: 'smooth', // remove 'smooth' if you want instant scroll
            });
        }
    }, [state?.page]); // Trigger whenever `data` changes

    const options = [
        { label: 'My Availability', value: '1' },
        { label: 'Edit Profile', value: '2' },
        { label: 'Change Password', value: '3' },
        // { label: 'Notifications', value: '4' }
    ];

    const month = [
        { label: 'jan', value: '1' },
        { label: 'feb', value: '2' },
    ];

    const dropDownSelector = (e) => {
        if (e.key === 'tmp-0') {
            navigate('/MyAvailability');
            return;
        } else if (e.key === 'tmp-1') {
            navigate('/EditProfile');
            return;
        } else if (e.key === 'tmp-2') {
            console.log(e.key);
            navigate('/ChangePassword');
            return;
        }
        // else if (e.key === 'tmp-3') {
        //     navigate('/Notifications')
        // }
    };
    const tabChangeHandler = (activeKey) => {
        setState({
            ...state,
            page: 1,
            tabKey: activeKey,
            filterDrawer: { ...state.filterDrawer },
        });
        dispatch(
            ShiftSchedulerAction.GetTodaysShifts({
                ...state,
                tabKey: activeKey,
                page: 1,
            }),
        );
    };

    // Fetch data for doughnut chart
    const fetchLineChartData = async (startDate, endDate) => {
        try {
            const response = await ApiCaller.Get(
                `/dashboard?reportsStartDate=${startDate}&reportsEndDate=${endDate}`,
            );
            const apiLineData = response.data.data.incidentsReports || [];

            const transformedLineData = apiLineData.map((item) => ({
                name: item.day, // Ensure 'day' matches the API response field
                incidents: item.incidents || 0, // Fallback to 0 if incidents are missing
            }));

            setLineChartData(transformedLineData);
            console.log('Updated Line Chart Data:', transformedLineData);
        } catch (error) {
            console.error('Error fetching line chart data:', error);
        }
    };

    function adjustOpacity(color, opacity = 0.25) {
        // Check if the color is a hex code
        if (color.startsWith('#')) {
            // Remove the '#' and convert the hex code to RGB
            const hex = color.slice(1);
            const r = parseInt(hex.slice(0, 2), 16);
            const g = parseInt(hex.slice(2, 4), 16);
            const b = parseInt(hex.slice(4, 6), 16);

            return `rgba(${r}, ${g}, ${b}, ${opacity})`;
        }

        // Check if the color is an rgb string
        if (color.startsWith('rgb')) {
            // Extract the rgb values
            const match = color.match(/^rgb\((\d+), (\d+), (\d+)\)$/);
            if (match) {
                const r = match[1];
                const g = match[2];
                const b = match[3];
                return `rgba(${r}, ${g}, ${b}, ${opacity})`;
            }
        }

        // Return the original color if it's not a hex or rgb string
        return color;
    }

    // Fetch data for the doughnut chart only
    const fetchDoughnutChartData = async (startDate, endDate) => {
        try {
            const response = await ApiCaller.Get(
                `/dashboard?analyticsStartDate=${startDate}&analyticsEndDate=${endDate}`,
            );
            const apiDoughnutData = response.data.data.incidentAnalytics || {};

            const transformedDoughnutData = {
                labels: ['Pending', 'Assigned'],
                datasets: [
                    {
                        data: [
                            apiDoughnutData.pending ?? 0,
                            apiDoughnutData.assigned ?? 0,
                        ],
                        backgroundColor: [colorPrimary, colorSecondary],
                        hoverBackgroundColor: [colorSecondary, colorPrimary],
                    },
                ],
            };

            setDoughnutChartData(transformedDoughnutData);
            console.log(
                'Updated Doughnut Chart Data:',
                transformedDoughnutData,
            );
        } catch (error) {
            console.error('Error fetching doughnut chart data:', error);
        }
    };

    const fetchShiftData = async () => {
        try {
            dispatch(ShiftSchedulerAction.GetShifts(state));
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
        }
    };

    // Handle date change
    // Handle date change for the line chart
    const handleLineChartDateChange = (dates) => {
        if (dates && dates.length === 2) {
            const [startDate, endDate] = dates;
            setLineChartDateRange(dates);
            fetchLineChartData(startDate, endDate); // Fetch line chart data only
        }
    };

    // Handle date change for the doughnut chart
    const handleDoughnutChartDateChange = (dates) => {
        if (dates && dates.length === 2) {
            const [startDate, endDate] = dates;
            setDoughnutChartDateRange(dates);
            fetchDoughnutChartData(startDate, endDate); // Fetch doughnut chart data only
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await ApiCaller.Get('/dashboard');
            console.log('API Response:', response.data);
            setData(response.data.data);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Default data fetch for both charts
    useEffect(() => {
        const defaultStartDate = '2025-01-01';
        const defaultEndDate = '2025-12-01';
        fetchData();

        // Initial fetch for line chart
        fetchLineChartData(defaultStartDate, defaultEndDate);

        // Initial fetch for doughnut chart
        fetchDoughnutChartData(defaultStartDate, defaultEndDate);

        // // Fetch data for the dashboard
        // fetchShiftData();
    }, []);
    useEffect(() => {
        // setResources([]);
        // setEvents([]);

        if (shiftRecords?.length > 0 || shiftRecords?.length == 0) {
            let updatedResources = [...resources];
            let updatedEvents = [...events];

            for (let item of shiftRecords) {
                let appliedUsers = item?.shiftUser.filter((item) => {
                    return item?.status == 'applied';
                });

                let acceptedUsers = item?.shiftUser.filter((item) => {
                    return item?.status == 'accepted';
                });

                let noOfAssigness = item?.numberOfAssignees;

                const startDate = item.shiftDate;
                // item.shiftDate !== null ? item.shiftDate : item.startDate;
                const endDate = item.shiftDate;
                // item.endDate || item.shiftDate;

                const startTimeString = `${startDate} ${item.startTime}`;
                const endTimeString = `${endDate} ${item.endTime}`;

                const startTimeMoment = moment(
                    startTimeString,
                    'YYYY-MM-DDThh:mm:ss',
                );
                const endTimeMoment = moment(
                    endTimeString,
                    'YYYY-MM-DDThh:mm:ss',
                );

                if (item?.shiftUser?.length > 0) {
                    for (let Users of item?.shiftUser) {
                        if (state?.tabKey == 0) {
                            let alreadyAddedResourceId = null;
                            if (updatedResources?.length > 0) {
                                const alreadyAddedResource =
                                    updatedResources?.find(
                                        (resource) =>
                                            resource?.email ==
                                            Users?.user?.email,
                                    );
                                const alreadyAddedResourceIdex =
                                    updatedResources?.findIndex(
                                        (resource) =>
                                            resource?.email ==
                                            Users?.user?.email,
                                    );
                                if (alreadyAddedResource) {
                                    alreadyAddedResourceId =
                                        alreadyAddedResource?.id;
                                    const mutatedResourceObject = {
                                        ...alreadyAddedResource,
                                        count: alreadyAddedResource?.count + 1,
                                    };
                                    updatedResources?.splice(
                                        alreadyAddedResourceIdex,
                                        1,
                                        mutatedResourceObject,
                                    );
                                } else {
                                    updatedResources?.push({
                                        id: Users?.user?.id,
                                        name:
                                            Users?.user?.firstName +
                                            ' ' +
                                            Users?.user?.lastName,
                                        image: Users?.user?.profileImg
                                            ? Users?.user?.profileImg[0]?.url
                                            : avatar,
                                        phoneNo: Users?.user?.phoneNo,
                                        email: Users?.user?.email,
                                        assignee: Users?.assignee,
                                        count: 1,
                                    });
                                }
                            } else {
                                updatedResources?.push({
                                    id: Users?.user?.id,
                                    name:
                                        Users?.user?.firstName +
                                        ' ' +
                                        Users?.user?.lastName,
                                    image: Users?.user?.profileImg
                                        ? Users?.user?.profileImg[0]?.url
                                        : avatar,
                                    phoneNo: Users?.user?.phoneNo,
                                    email: Users?.user?.email,
                                    assignee: Users?.assignee,
                                    count: 1,
                                });
                            }
                            //
                            // resources?.push({
                            //     id: Users?.id,
                            //     name:
                            //         Users?.user?.firstName +
                            //         ' ' +
                            //         Users?.user?.lastName,
                            //     image: Users?.user?.profileImg
                            //         ? Users?.user?.profileImg[0]?.url
                            //         : avatar,
                            // });
                            updatedEvents?.push({
                                id: item?.id,
                                break: item?.break,
                                howMany: item?.howMany,
                                start: startTimeMoment,
                                end: endTimeMoment,
                                property: item?.property
                                    ? item?.property?.name
                                    : '',
                                resourceId:
                                    alreadyAddedResourceId !== null
                                        ? alreadyAddedResourceId
                                        : Users?.id,
                                title: startTimeString + ' - ' + endTimeString,
                                bgColor:
                                    Users?.status == 'accepted'
                                        ? item?.siteColor || '#5fdba7'
                                        : { colorPrimary },
                                location: item?.address
                                    ? `${item.address?.streetNumber},${item.address?.streetName},${item.address?.city},${item.address?.buildingNumber}`
                                    : '',
                                Eligibility: item?.eligibilitity
                                    ? item?.eligibilitity?.name
                                    : '',
                                Schedules:
                                    Users?.user?.schedules[0]?.name + '...',
                                assignedBy: Users?.assignee
                                    ? Users?.assignee?.firstName +
                                      ' ' +
                                      Users.assignee?.lastName
                                    : '-',
                                duration: `${startTimeString} - ${endTimeString}`,
                                status: Users?.status,
                                tabKey: state?.tabKey,
                                userId: Users?.user?.id,
                            });
                        } else {
                            if (
                                appliedUsers?.length > 0 &&
                                Users?.status == 'applied' &&
                                acceptedUsers?.length < noOfAssigness
                            ) {
                                updatedResources?.push({
                                    id: appliedUsers[0]?.id,
                                    name:
                                        'Unassigned \n' +
                                        'Applied : ' +
                                        appliedUsers?.length +
                                        '\nAvailable Slots:' +
                                        noOfAssigness,

                                    image: avatar,
                                    phoneNo: Users?.user?.phoneNo,
                                    email: Users?.user?.email,
                                    assignee: Users?.assignee,
                                });

                                updatedEvents.push({
                                    id: item?.id,
                                    break: item?.break,
                                    howMany: item?.howMany,
                                    start: startTimeMoment,
                                    end: endTimeMoment,
                                    property: item?.property
                                        ? item?.property?.name
                                        : '',
                                    resourceId: appliedUsers[0]?.id,
                                    title:
                                        startTimeString + ' - ' + endTimeString,
                                    bgColor: item?.siteColor || {
                                        colorPrimary,
                                    },
                                    location: item?.address
                                        ? `${item.address?.streetNumber},${item.address?.streetName},${item.address?.city},${item.address?.buildingNumber}`
                                        : '',
                                    Eligibility: item?.eligibilitity
                                        ? item?.eligibilitity?.name
                                        : '',
                                    Schedules: '-',
                                    assignedBy: appliedUsers[0]?.assignee
                                        ? appliedUsers[0]?.assignee?.firstName +
                                          ' ' +
                                          appliedUsers[0]?.assignee?.lastName
                                        : '-',
                                    assignedByImage:
                                        appliedUsers[0]?.assignee?.profileImg[0]
                                            ?.url,
                                    // 'https://fastly.picsum.photos/id/1/200/300.jpg?hmac=jH5bDkLr6Tgy3oAg5khKCHeunZMHq0ehBZr6vGifPLY',

                                    duration: `${startTimeString} - ${endTimeString}`,
                                    status: appliedUsers[0]?.status,
                                    tabKey: state?.tabKey,
                                    completeRecord: item,
                                    shiftDetailHandler,
                                    userId: Users?.user?.id,
                                });

                                appliedUsers = [];
                            } else if (Users?.status !== 'applied') {
                                updatedResources?.push({
                                    id: Users?.user?.id,
                                    name:
                                        Users?.user?.firstName +
                                        ' ' +
                                        Users?.user?.lastName,
                                    image: Users?.user?.profileImg
                                        ? Users?.user?.profileImg[0]?.url
                                        : avatar,
                                    phoneNo: Users?.user?.phoneNo,
                                    email: Users?.user?.email,
                                    assignee: Users?.assignee,
                                });

                                updatedEvents?.push({
                                    id: item?.id,
                                    break: item?.break,
                                    howMany: item?.howMany,
                                    start: startTimeMoment,
                                    end: endTimeMoment,
                                    property: item?.property
                                        ? item?.property?.name
                                        : '',
                                    resourceId: Users?.id,
                                    title:
                                        startTimeString + ' - ' + endTimeString,
                                    bgColor: item?.siteColor || '#5fdba7',
                                    location: item?.address
                                        ? `${item.address?.streetNumber},${item.address?.streetName},${item.address?.city},${item.address?.buildingNumber}`
                                        : '',
                                    Eligibility: item?.eligibilitity
                                        ? item?.eligibilitity?.name
                                        : '',
                                    Schedules:
                                        Users?.user?.schedules[0]?.name + '...',
                                    assignedBy: Users?.assignee
                                        ? Users?.assignee?.firstName +
                                          ' ' +
                                          Users.assignee?.lastName
                                        : '-',
                                    duration: `${startTimeString} - ${endTimeString}`,
                                    status: Users?.status,
                                    tabKey: state?.tabKey,
                                    completeRecord: item,
                                    userId: Users?.user?.id,
                                });
                            }
                        }
                    }
                } else if (state?.tabKey !== 0) {
                    updatedResources?.push({
                        id: item?.id,
                        name:
                            'Unassigned \n' +
                            'Applied : 0' +
                            '\nAvailable Slots:' +
                            noOfAssigness,
                        image: avatar,
                    });

                    updatedEvents?.push({
                        id: item?.id,
                        break: item?.break,
                        howMany: item?.howMany,
                        start: startTimeMoment,
                        end: endTimeMoment,
                        property: item?.property ? item?.property?.name : '',
                        resourceId: item?.id,
                        title: startTimeString + ' - ' + endTimeString,
                        bgColor: item?.siteColor || { colorPrimary },
                        location: item?.address
                            ? `${item.address?.streetNumber},${item.address?.streetName},${item.address?.city},${item.address?.buildingNumber}`
                            : '',
                        Eligibility: item?.eligibilitity
                            ? item?.eligibilitity?.name
                            : '',
                        Schedules: '-',
                        assignedBy: '-',
                        duration: `${startTimeString} - ${endTimeString}`,
                        status: 'not applied',
                        tabKey: state?.tabKey,
                        completeRecord: item,
                        shiftDetailHandler,
                    });

                    appliedUsers = [];
                }
            }

            setResources(updatedResources);
            setEvents(updatedEvents);
        }
    }, [shiftRecords, state?.tabKey]);

    console.log('eventsNresources', events, resources);

    const paginationHandler = (page, limit) => {
        const { schedule, user, eligiblity } = state?.filterDrawer;
        const { tabKey } = state;
        setState((prev) => ({
            ...prev,
            page: page,
            limit: 100,
            filterDrawer: {
                schedule: schedule,
                user: user,
                eligiblity: eligiblity,
            },
        }));
        setResources([]);
        setEvents([]);
        dispatch(
            ShiftSchedulerAction.GetShifts({
                page,
                limit,
                tabKey,
                filterDrawer: {
                    schedule: schedule,
                    user: user,
                    eligiblity: eligiblity,
                },
            }),
        );
    };

    function reduceOpacity(color) {
        if (color.startsWith('rgba')) {
            const rgba = color.match(
                /rgba\((\d+), (\d+), (\d+), (\d(\.\d+)?)\)/,
            );
            if (rgba) {
                const r = rgba[1];
                const g = rgba[2];
                const b = rgba[3];
                const alpha = parseFloat(rgba[4]) * 0.25;
                return `rgba(${r}, ${g}, ${b}, ${alpha})`;
            }
        }

        if (color.startsWith('#')) {
            const r = parseInt(color.slice(1, 3), 16);
            const g = parseInt(color.slice(3, 5), 16);
            const b = parseInt(color.slice(5, 7), 16);
            return `rgba(${r}, ${g}, ${b}, 0.25)`;
        }

        if (color.startsWith('rgb')) {
            const rgb = color.match(/rgb\((\d+), (\d+), (\d+)\)/);
            if (rgb) {
                const r = rgb[1];
                const g = rgb[2];
                const b = rgb[3];
                return `rgba(${r}, ${g}, ${b}, 0.25)`;
            }
        }

        return color;
    }

    // data receiving from the scroller component.
    const schedulerScrollDataHandler = (resp) => {
        dispatch(ShiftSchedulerAction.GetShiftsSuccess(resp?.data));
        // handling forcefully stop hasMore scenerio for the scroll component to not show loading state.
        let totalCurrentSchedulesCount =
            totalScheduleObjectCount + state?.limit;
        if (totalCurrentSchedulesCount >= resp?.data?.paginate?.total) {
            setForceFullyStopHasMoreShifts(true);
        } else {
            setForceFullyStopHasMoreShifts(false);
        }
        setTotalScheduleObjectCount(totalCurrentSchedulesCount);
        setState({ ...state, page: resp?.data?.paginate?.currentPage });
        return resp?.data?.data;
    };

    const [markersMap, setMarkersMap] = useState({});
    const [selectedUser, setSelectedUser] = useState(null);
    const guardCompanyId = useSelector(
        (state) => state?.AppReducer?.user?.guardCompany?.id,
    );
    const SOCKET_URL = `${process.env.REACT_APP_SOCKET_HOST}:${process.env.REACT_APP_SOCKET_PORT}`;

    const menuItems = [
        {
            label: 'Pending Requests',
            value: data?.pendingDropSwapRequests,
            icon: <FaFileShield size={30} style={{ color: colorPrimary }} />,
        },
        {
            label: 'Open Shifts',
            value: data?.openShifts,
            icon: <FaClock size={30} style={{ color: colorPrimary }} />,
        },
        {
            label: 'Live Tracking',
            value:
                (data?.companyUsers ? data?.companyUsers : 0) +
                '/' +
                Object.keys(markersMap).length,
            icon: <FaUserSecret size={30} style={{ color: colorPrimary }} />,

            navigate: handleOpenModal,
        },
        {
            label: 'Shift For Today',
            value: data?.currentDayShiftsCount,
            icon: (
                <BiSolidCalendarEdit
                    size={30}
                    style={{ color: colorPrimary }}
                />
            ),
        },
    ];
    // Initial Fetch & Socket Setup
    useEffect(() => {
        let socket;

        const initLiveTracking = async () => {
            try {
                // 1. Initial Fetch
                const res = await ApiCaller.Get(
                    '/guard-company/live-locations',
                );
                const initialGuards = res?.data?.data || [];

                const markersData = {};
                initialGuards.forEach((guard) => {
                    if (
                        guard.currentLocation?.latitude &&
                        guard.currentLocation?.longitude
                    ) {
                        markersData[guard.id] = guard;
                    }
                });
                setMarkersMap(markersData);

                // 2. Setup Socket Connection
                const token = JSON.parse(localStorage.getItem('authToken'));
                socket = io(SOCKET_URL, {
                    transports: ['websocket'],
                    auth: {
                        token: token,
                    },
                });
                socket.on('connect', () => {
                    console.log('socket connected', socket?.id);
                });
                console.log(socket, guardCompanyId, 'socketssssssssss');

                if (guardCompanyId) {
                    socket.emit('joinRoom', {
                        room: `guardCompany.${guardCompanyId}`,
                    });
                }

                socket.on('guardLocationUpdated', (payload) => {
                    console.log(payload, 'Socket burhan payload');

                    if (
                        payload &&
                        payload.id &&
                        payload.currentLocation?.latitude &&
                        payload.currentLocation?.longitude
                    ) {
                        setMarkersMap((prev) => ({
                            ...prev,
                            [payload.id]: {
                                ...prev[payload.id],
                                ...payload,
                            },
                        }));

                        // Update selected user info in real-time if it's currently open
                        setSelectedUser((prevSelected) => {
                            if (
                                prevSelected &&
                                prevSelected.id === payload.id
                            ) {
                                return { ...prevSelected, ...payload };
                            }
                            return prevSelected;
                        });
                    }
                });
            } catch (err) {
                console.error('Failed to fetch live locations', err);
            }
        };

        initLiveTracking();

        // 3. Cleanup on unmount
        return () => {
            if (socket) {
                socket.disconnect();
            }
        };
    }, [guardCompanyId]);

    return (
        <>
            <DashboardActionBar />

            <Row gutter={12}>
                {menuItems.map(({ value, label, icon, navigate }) => (
                    <Col xl={6} lg={8} sm={12} xs={24} key={label}>
                        <div
                            className={`flex items-center py-5 px-6 gap-3 rounded-lg mb-2 bg-white shadow-[rgba(149,157,165,0.2)_0px_8px_24px] ${
                                navigate ? 'cursor-pointer' : 'cursor-default'
                            }`}
                            onClick={navigate || undefined}
                        >
                            <div
                                className="shadow-large flex items-center justify-center rounded-full p-1 w-14 h-14"
                                style={{
                                    backgroundColor:
                                        reduceOpacity(colorPrimary), // Apply the background color with reduced opacity
                                    boxShadow: `0px 4px 8px ${reduceOpacity(colorPrimary)}`, // Apply shadow with reduced opacity color
                                }}
                            >
                                {icon}
                            </div>

                            {/* Display the FaClock icon here */}
                            <div className="flex flex-col items-start justify-start">
                                <p className="text-2xl font-bold">
                                    {value}{' '}
                                    {label === 'Shift For Today' && (
                                        <span
                                            className="text-xs text-blue-500 cursor-pointer mt-1 hover:underline"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleOpenGuardsModal();
                                            }}
                                        >
                                            {' '}
                                            See Details
                                        </span>
                                    )}
                                </p>
                                <p className="text-sm text-[#aaa]">{label}</p>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>

            {/* Scheduler component */}
            <Row className="w-full py-5 px-2 bg-white">
                <Col
                    span={24}
                    className="px-2 flex items-center justify-between flex-wrap"
                >
                    <BasicText
                        text={'Today Schedule'}
                        className="text-xl font-semibold"
                    />
                </Col>

                <>
                    <div
                        id="scrollableDiv"
                        ref={scrollContainerRef}
                        style={{
                            height: resources?.length < 4 ? 400 : 'fit-content',
                            maxHeight: 600,
                            overflow: 'auto',
                            width: '100%',
                        }}
                    >
                        <LoadOnScroll
                            endPoint={`/shifts`}
                            restQueryParams={`perPage=${state?.limit}&open_shift=${0}&startDate=${currentWeekStart}&endDate=${currentWeekEnd}`}
                            // height={300}
                            scrollableTarget="scrollableDiv"
                            hasMore={shiftsHasMore}
                            setHasMore={setShiftsHasMore}
                            scrollItems={events}
                            scrollDataHandler={schedulerScrollDataHandler}
                            stopHasMoreScenerioConditionally={
                                forceFullyStopHasMoreShifts
                            }
                            scrollThreshold={1}
                            endMessage={'No more shifts to show'}
                            loadingSpinner={true}
                            children={
                                <App
                                    itsAllowDrag={false}
                                    events={events}
                                    resources={resources}
                                    currentSchedulerState={state}
                                    currentConfigOfScheduler={
                                        currentConfigOfScheduler
                                    }
                                    setCurrentConfigOfScheduler={
                                        setCurrentConfigOfScheduler
                                    }
                                    tabKey={null}
                                />
                            }
                        />
                    </div>

                    {/* <Col
                            span={24}
                            className="flex items-center justify-end"
                        >
                            <Pagination.Basic
                                total={paginate?.total}
                                pageSize={state?.limit}
                                current={state?.page}
                                onChange={paginationHandler}
                                showSizeChanger={''}
                                containerStyle={{ marginRight: '24px' }}
                            />
                        </Col> */}
                </>
            </Row>

            <Row className="w-full flex items-start justify-between my-6 h-full">
                {/* Incident Reports Line Chart */}
                <Col
                    xl={24}
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                    className="py-3 px-3 rounded-lg self-start h-full mb-3 bg-white shadow-[rgba(0,0,0,0.16)_0px_10px_36px_0px,rgba(0,0,0,0.06)_0px_0px_0px_1px]"
                >
                    <Row className="w-full flex items-center justify-between px-1 py-2 mb-5">
                        <Col lg={8}>
                            <BasicText
                                text={'Incident Reports'}
                                className="text-base font-semibold"
                            />
                        </Col>
                        <Col
                            lg={12}
                            className="flex items-center justify-between gap-1"
                        >
                            <RangeDatePicker
                                className="w-full"
                                value={lineChartDateRange}
                                onChange={handleLineChartDateChange}
                            />
                        </Col>
                    </Row>

                    <Row className="w-full h-full">
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <ResponsiveContainer width={'100%'} height={295}>
                                <LineChart
                                    data={lineChartData}
                                    margin={{ top: 15, bottom: 15 }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Line
                                        type="monotone"
                                        dataKey="incidents"
                                        stroke={colorPrimary}
                                        strokeWidth={2}
                                        isAnimationActive={true}
                                        animationBegin={2}
                                        animationEasing="ease-in-out"
                                        dot={{
                                            stroke: { colorPrimary },
                                            strokeWidth: 2,
                                        }}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </Col>
                    </Row>
                </Col>

                {/* Incident Analytics Doughnut Chart */}
                <Col
                    xl={24}
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                    className="rounded-lg p-3 h-full bg-white shadow-[rgba(0,0,0,0.16)_0px_10px_36px_0px,rgba(0,0,0,0.06)_0px_0px_0px_1px]"
                >
                    <Row className="w-full flex items-center justify-between px-1 py-2 mb-3">
                        <Col lg={11} md={15} sm={15} xs={12}>
                            <BasicText
                                text={'Incident Analytics'}
                                className="text-base font-semibold"
                            />
                        </Col>
                        <Col
                            lg={13}
                            md={9}
                            sm={9}
                            xs={12}
                            className="flex justify-end"
                        >
                            <Col
                                lg={10}
                                className="flex items-center justify-between gap-1"
                            >
                                <RangeDatePicker
                                    className="w-full"
                                    value={doughnutChartDateRange}
                                    onChange={handleDoughnutChartDateChange}
                                />
                            </Col>
                        </Col>
                    </Row>
                    <Row className="w-full flex items-center justify-center relative">
                        <Col className="h-full">
                            {Object.keys(doughnutChartData).length > 0 && (
                                <DoughnutChart data={doughnutChartData} />
                            )}
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Modal
                title="Live Tracking"
                visible={isModalVisible}
                onCancel={() => setModalVisible(false)}
                footer={null}
                width={800}
                destroyOnClose
            >
                {isModalVisible && (
                    <LiveTracking
                        markersMap={markersMap}
                        selectedUser={selectedUser}
                        setSelectedUser={setSelectedUser}
                    />
                )}
            </Modal>
            <Modal
                title="Today's Guards"
                visible={isGuardsModalVisible}
                onCancel={handleCloseGuardsModal}
                footer={null}
                width={600}
            >
                <div
                    style={{
                        maxHeight: 400,
                        overflowY: 'auto',
                        padding: '10px',
                    }}
                >
                    <p className="font-semibold text-lg mb-4">
                        Total Guards Today: {todayGuards.length}
                    </p>
                    <List
                        itemLayout="horizontal"
                        dataSource={todayGuards}
                        renderItem={(item) => (
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<Avatar src={item.image} />}
                                    title={item.name}
                                    description={
                                        item.email || 'No email provided'
                                    }
                                />
                            </List.Item>
                        )}
                    />
                </div>
            </Modal>
        </>
    );
};
export default Dashboard;
